import { graphql } from "gql";

const INTERNAL_ADMIN_TAG_CATEGORY_QUERY = graphql(`
  query InternalAdminTagCategory($id: [ID!]!) {
    internalAdminTagCategory(id: $id) {
      ...InternalAdminTagCategory
    }
  }
`);

export default INTERNAL_ADMIN_TAG_CATEGORY_QUERY;
